module.exports = __webpack_public_path__ + "static/contentP2-8330ca26c52e5fc8e8047e35ce44f74e.png";